<template>
    <div class="create">
        <el-dialog title="添加" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
            <div class="main">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="left" class="demo-ruleForm">
                    <el-form-item label="安装类型：" prop="name">
                        <el-select v-model="ruleForm.level" placeholder="请选择级别">
                            <el-option label="全部" value="0"></el-option>
                            <el-option label="活动名称" value="1"></el-option>
                            <el-option label="快递单号" value="2"></el-option>
                            <el-option label="联系人" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="安装产品：" prop="name">
                        <el-input v-model="ruleForm.name" clearable placeholder="请输入安装产品，多个以英文逗号隔开"></el-input>
                    </el-form-item>
                    <el-form-item label="安装区域：" prop="name">
                        <el-select v-model="ruleForm.level" placeholder="请选择级别">
                            <el-option label="全部" value="0"></el-option>
                            <el-option label="活动名称" value="1"></el-option>
                            <el-option label="快递单号" value="2"></el-option>
                            <el-option label="联系人" value="3"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="服务类型：" prop="type">
                        <el-radio-group v-model="ruleForm.type">
                            <el-radio :label="1">自营</el-radio>
                            <el-radio :label="2">外包</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="table">
                    <p style="margin-bottom: 22px">服务人员：</p>
                    <el-table :data="tableData" style="width: 100%" v-loading="tabload">
                        <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
                        <el-table-column prop="title" label="人员姓名" align="center"> </el-table-column>
                        <el-table-column prop="receive_name" label="人员电话" align="center"> </el-table-column>
                        <el-table-column prop="receive_phone" label="身份证号码" align="center"> </el-table-column>
                        <el-table-column prop="express_no" label="证件" align="center"> </el-table-column>
                        <el-table-column prop="opt" label="操作" align="center" fixed="right">
                            <template slot-scope="scope">
                                <div class="link">
                                    <el-link type="primary" @click="detail(scope.row.id)">编辑</el-link>
                                    <el-link type="primary" @click="detail(scope.row.id)">取消</el-link>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="medium">+ 添 加</el-button>
                <el-button @click="handleClose" size="medium">取 消</el-button>
                <el-button @click="handleClose" type="primary" size="medium">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabload: false,
            tableData: [],
            fileList: [],
            activeName: 'first',
            dialogVisible: false,
            load: false,
            ruleForm: {},
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入活动名称',
                        trigger: 'blur',
                    },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
            },
            tagList: ['产品监控', '上传店铺信息', '上传授权信息', '安装服务', '售后服务'],
            delTagList: [],
        }
    },
    methods: {
        selPro(type) {
            this.$emit('selectProduct', type)
        },
        handleExceed(files, fileList) {
            this.$message.warning('最多只能上传一个文件！')
        },
        addTag(i, v) {
            this.tagList.splice(i, 1)
            this.delTagList.push(v)
        },
        closeTag(i, v) {
            this.delTagList.splice(i, 1)
            this.tagList.push(v)
        },
        handleClose() {
            this.dialogVisible = false
        },
    },
}
</script>

<style lang="scss" scoped>
.main {
    max-height: 550px;
    overflow-y: auto;

    &::-webkit-scrollbar-track-piece {
        background: #d3dce6;
    }

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 20px;
    }
    .demo-ruleForm {
        h3 {
            margin-bottom: 20px;
            padding: 10px 0;
        }
        ::v-deep .el-form-item {
            width: 500px;
        }
    }
    .tag-group {
        padding-top: 10px;
        padding-bottom: 40px;
        .el-tag {
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;
            height: 34px !important;
            line-height: 34px !important;
            font-size: 14px;
        }
    }
    .el-date-editor .el-range-separator {
        width: auto !important;
    }
    .upload-demo {
        position: relative;
        .down {
            position: absolute;
            right: 180px;
            top: 0;
            .el-link {
                font-size: 12px;
                line-height: 20px;
            }
        }
    }
    ::v-deep .el-table th {
        background: #fafafa;
        padding: 10px 0;
    }
}
</style>